import { lang } from "src/language/Strings";

export function DataCard({
  id,
  onClick,
  isSelected,
  header,
  imageUrl,
  firstRowInput,
  secondRowInput,
  thirdRowInput,
}: {
  id: string;
  onClick: () => void;
  isSelected: boolean;
  imageUrl?: string;
  header: string;
  firstRowInput: string;
  secondRowInput: string;
  thirdRowInput: React.ReactNode;
}) {
  return (
    <div
      className={`border-2 relative border-solid border-Grey4 border-l-4 border-b-2 grid grid-cols-7 p-1 h-28 min-h-28 select-none overflow-hidden ${
        isSelected && "bg-Grey4"
      }`}
      onClick={onClick}
      id={`DataCard-${id}`}
      key={`DataCard-${id}`}
    >
      <div className="h-28 items-center col-span-2 p-2 flex pb-4">
        {imageUrl ? (
          <img
            className="h-full w-auto object-contain rounded-lg"
            src={imageUrl}
            title={`Thumbnail for id: ${id}`}
          />
        ) : null}
      </div>
      <div className="h-full col-span-4 pl-2 flex flex-col justify-between py-1">
        <div className="truncate">{header}</div>
        {<div className="text-[#1242BA] truncate ">{firstRowInput}</div>}

        <div className="p-1 text-sm truncate">{secondRowInput}</div>
        {
          <div className="text-PrimaryRed">
            {thirdRowInput as React.ReactNode}
          </div>
        }
      </div>
      <div className="h-full col-span-1 items-center flex p-2">
        <i className="fa-solid fa-greater-than text-PrimaryGreen text-3xl"></i>
      </div>
    </div>
  );
}
